import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { LocationOptions, LocationData } from '../../../../shared/location-picker/location-picker.component';

@Component({
  selector: 'app-location-picker-dialog',
  templateUrl: './location-picker-dialog.component.html',
  styleUrls: ['./location-picker-dialog.component.css']
})
export class LocationPickerDialogComponent implements OnInit {




  defaultLocation : LocationData;
  locations = new Array<LocationData>();
  locationOptions : LocationOptions; 


  constructor(public dialogRef: MatDialogRef<LocationPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

      
      this.locationOptions = data.locationOptions;
      this.locationOptions.searchBoxText = "Type address here...";
      this.locationOptions.finalLocationFromSearchBar = true;
    }

  ngOnInit() {
    
  }

  locationSelected(locationData){

      this.locations = locationData;
  }

  closeDialog(){
    this.dialogRef.close(this.locations);
  }
}
